import { intercepted2ogpsikxxj4u0 as intercepted } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl } from '../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CancellableContinuationImpl.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { PlatformUtils_getInstanceitqdjrwn2jrm as PlatformUtils_getInstance } from '../../../../../../../ktor-ktor-utils/io/ktor/util/PlatformUtils.mjs';
import {
  Companion_instance25ullnynvxd0w as Companion_instance,
  _Result___init__impl__xyqfz83a5421h46yeyh as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
import { Error3ofk6owajcepa as Error_0 } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { readBodyBrowser2vmfk0na3k29n as readBodyBrowser } from '../browser/BrowserFetch.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function commonFetch(input, init, requestConfig, config, callJob, $completion) {
  var cancellable = new (CancellableContinuationImpl())(intercepted($completion), 1);
  cancellable.c11();
  var continuation = cancellable;
  var controller = AbortController_0();
  init.signal = controller.signal;
  config.n5z_1(init);
  requestConfig(init);
  callJob.jx(true, VOID, (it) => {
    controller.abort();
    return Unit_instance;
  });
  var tmp;
  if (PlatformUtils_getInstance().z4n_1) {
    tmp = fetch(input, init);
  } else {
    var options = Object.assign(Object.create(null), init, config.o5z_1);
    tmp = fetch(input, options);
  }
  var promise = tmp;
  var tmp_0 = (it) => {
    // Inline function 'kotlin.coroutines.resume' call
    var this_0 = continuation;
    // Inline function 'kotlin.Companion.success' call
    var tmp$ret$0 = _Result___init__impl__xyqfz8(it);
    this_0.tc(tmp$ret$0);
    return Unit_instance;
  };
  promise.then(tmp_0, (it) => {
    var tmp0 = continuation;
    // Inline function 'kotlin.coroutines.resumeWithException' call
    // Inline function 'kotlin.Companion.failure' call
    var exception = Error_0().oe('Fail to fetch', it);
    var tmp$ret$2 = _Result___init__impl__xyqfz8(createFailure(exception));
    tmp0.tc(tmp$ret$2);
    return Unit_instance;
  });
  return cancellable.my();
}
function readBody(_this__u8e3s4, response) {
  return readBodyBrowser(_this__u8e3s4, response);
}
function AbortController_0() {
  return new AbortController();
}
//region block: exports
export {
  commonFetch as commonFetch16pkr2nd4pdev,
  readBody as readBody4gczno2wau05,
};
//endregion

//# sourceMappingURL=Utils.mjs.map
